import type { FaireProductEntity } from "../../entity_types/product";

export const p_62g9z9ejx3: FaireProductEntity = {
  token: "p_62g9z9ejx3",
  type: "product",
  name: "Vegan Cashew Garlic Parmesan Cheeze",
  brandName: "Upscaling Demo Brand",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/0f54e49e41b800016144726220c312274473d5557bb1b4aa41299f8633f4e4ac.jpeg",
  afterImageUrl:
    "https://cdn.prerelease.faire.dev/fastly/55834665bf26f61b7d464207d793f69eeb71ca7e2f1ac553e715e138c058c76e.jpeg",
  priceDollars: 24,
  description: "Image upscaling comparison product.",
  categoryTokens: ["cat_proto_image-upscaling"],
  tags: ["upscaling"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
